import type { VisibilityScopeValue } from "../../../components/ui/VisibilityScope";
import type { ScrewFamily, ScrewFamilyForSettings } from "./screwFamilies";

export const SUPPORT_FAMILY_CODE_JFA = "jfa";
export const SUPPORT_FAMILY_CODE_SUP_S = "sup-s";
export const SUPPORT_FAMILY_CODE_SUP_M = "sup-m";
export const SUPPORT_FAMILY_CODE_SUP_L = "sup-l";
export const SUPPORT_FAMILY_CODE_NAG = "nag";
export const SUPPORT_FAMILY_CODE_GRANULO = "granulo";

export const SUPPORT_FAMILY_CODES = [
  SUPPORT_FAMILY_CODE_JFA,
  SUPPORT_FAMILY_CODE_SUP_S,
  SUPPORT_FAMILY_CODE_SUP_M,
  SUPPORT_FAMILY_CODE_SUP_L,
  SUPPORT_FAMILY_CODE_NAG,
  SUPPORT_FAMILY_CODE_GRANULO,
] as const;

export type KnownSupportFamilyCode = (typeof SUPPORT_FAMILY_CODES)[number];

export type SupportFamily = {
  code: string;
  name: string;
  nameIt: string | null;
  nameDe: string | null;
  nameFr: string | null;
  nameEs: string | null;
  maxLiveLoad: number | null;
  screwFamilies: ScrewFamily[];
  visibility: VisibilityScopeValue;
  order: number;
};

// User side (settings, saved configuration): name already in the user's language.
export type SupportFamilyForSettings = Omit<
  SupportFamily,
  "nameIt" | "nameDe" | "nameFr" | "nameEs" | "screwFamilies" | "visibility" | "order"
> & {
  screwFamilies: ScrewFamilyForSettings[];
};

export type SearchSupportFamiliesResponse = {
  items: SupportFamily[];
  total: number;
};

// export type InsertSupportFamilyBody = {
//   code: string;
//   name: string;
//   nameIt: string | null;
//   nameDe: string | null;
//   nameFr: string | null;
//   nameEs: string | null;
//   maxLiveLoad: number | null;
//   screwFamilies: ScrewFamily[];
// };

export type UpdateSupportFamilyBody = {
  name: string;
  nameIt: string | null;
  nameDe: string | null;
  nameFr: string | null;
  nameEs: string | null;
  maxLiveLoad: number | null;
  screwFamilies: ScrewFamily[];
};
